import React, { useState, useEffect } from 'react'
import { useHistory, Link } from 'react-router-dom'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { SearchIcon, ClearIcon, RestoreIcon } from './Icons'
import Spinner from '../assets/images/spinner.gif'

const RECENT_SEARCH_VARIABLE = 'recentSearch'
const useStyles = makeStyles(theme => ({
  SpinnerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: 20,
    },
  },
  searchMobileContent: {
    position: 'absolute',
    width: '100%',
    height: '100vh',
    background: '#f5f8ff',
    left: 0,
    top: 0,
    boxSizing: 'border-box',
    padding: '24px 20px',
    transition: 'all 0.3s',
    zIndex: 100,
  },
  searchMobileHead: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    height: 64,
  },
  searchMobileResult: {
    height: 'calc(100% - 64px)',
    overflow: 'auto',
  },
  searchMobileBox: {
    width: 'calc(100% - 100px)',
    position: 'relative',
    height: 40,
    boxSizing: 'border-box',
    border: '1px solid #064C9B',
    borderRadius: 3,
    background: 'white',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  searchMobileCancel: {
    width: '50px',
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#474747',
  },
  searchMobileSearchIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 12,
  },
  searchMobileClearIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 12,
  },
  searchMobileSearchInput: {
    width: '100%',
    height: '100%',
    background: 'transparent',
    border: 'none',
    paddingRight: 12,
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    '&:active': {
      border: 'none',
      outline: 'none',
    },
    '&:focus': {
      border: 'none',
      outline: 'none',
    },
  },
  searchMobileListContainer: {
    marginBottom: 20,
  },
  searchMobileListHeadTitle: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 600,
    color: '#474747',
    marginBottom: 8,
  },
  searchMobileListItemContainer: {},
  searchMobileListItemCache: {
    marginBottom: 8,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  searchMobileListItemCacheLeft: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  searchMobileListItemCacheRight: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  searchMobileListItem: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#474747',
    marginBottom: 8,
  },
  searchMobileListItemCacheReloadIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  searchMobileListItemCacheReloadText: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    color: '#474747',
    marginLeft: 8,
  },
}))

const SearchMobile = (props: any) => {
  const classes = useStyles()
  const onClose = () => {
    props.setToggleSearch(false)
    setFocus(false)
  }

  const [focus, setFocus] = useState(false)
  const [toggleClose, setToggleClose] = useState(true)
  const [inputValue, setInputValue] = useState('')
  const [breakStep, setBreakStep] = useState(1)
  const [recent, setRecent] = useState<any>([])
  const [dymamicSearchList, setDynamicSearchList] = useState(props.searchList)
  const visibleCount = 20 + 15 * (breakStep - 1)
  const history = useHistory()
  let timeout: any = null

  useEffect(() => {
    setDynamicSearchList(props.searchList)
  }, [props.searchList])

  useEffect(() => {
    history.listen((location, action) => {
      setInputValue('')
    })

    if (localStorage.getItem(RECENT_SEARCH_VARIABLE)) {
      let recentSearch: any = localStorage.getItem(RECENT_SEARCH_VARIABLE)
      setRecent(JSON.parse(recentSearch))
    }
    return () => {
      window.clearTimeout(timeout)
    }
  }, [])

  const onHandleChangeInput = (event: any) =>
    getSearchResultByString(event.target.value)

  const getSearchResultByString = (str: string) => {
    setInputValue(str)
    setBreakStep(1)
    const cloned = JSON.parse(JSON.stringify(props.searchList))
    const filteredList = cloned.filter(
      (item: any) =>
        item.searchTerm.toLowerCase().indexOf(str.toLowerCase()) !== -1,
    )
    setDynamicSearchList(filteredList)

    let recentSearch: any = localStorage.getItem(RECENT_SEARCH_VARIABLE)
    const clonedRecent =
      JSON.parse(JSON.stringify(JSON.parse(recentSearch))) === null
        ? []
        : JSON.parse(JSON.stringify(JSON.parse(recentSearch)))
    const filteredRecentList = clonedRecent.filter(
      (item: any) =>
        item.searchTerm.toLowerCase().indexOf(str.toLowerCase()) !== -1,
    )
    setRecent(filteredRecentList)
  }

  const onHandleClearInput = () => {
    setInputValue('')
    getSearchResultByString('')
    setToggleClose(false)
  }

  const onHandleClickItem = (val: any) => {
    setFocus(false)
    setInputValue(val.proper_name)
    history.push(`/company/${val.ticker}`)
    let recentSearch: any = localStorage.getItem(RECENT_SEARCH_VARIABLE)
    if (recentSearch !== null) {
      const existedLocalList = JSON.parse(recentSearch)
      const isItemExistedInLocal =
        existedLocalList.filter(
          (item: any) => item.proper_name === val.proper_name,
        ).length !== 0
      if (!isItemExistedInLocal) {
        localStorage.setItem(
          RECENT_SEARCH_VARIABLE,
          JSON.stringify(
            [
              {
                ...val,
                recent: true,
              },
              ...recent,
            ].slice(0, 4),
          ),
        )
      }
    } else {
      localStorage.setItem(
        RECENT_SEARCH_VARIABLE,
        JSON.stringify([
          {
            ...val,
            recent: true,
          },
        ]),
      )
    }
  }

  const onClearItemFromLocal = (e: any, option: any) => {
    e.stopPropagation()
    setRecent(recent.filter((i: any) => i.ticker !== option.ticker))
    localStorage.setItem(
      'recentSearch',
      JSON.stringify(recent.filter((i: any) => i.ticker !== option.ticker)),
    )
  }

  const handleScrollContent = (evt: any) => {
    if (dymamicSearchList.length <= visibleCount) return
    if (
      evt.target.scrollHeight - evt.target.scrollTop <=
      evt.target.clientHeight + 10
    ) {
      window.clearTimeout(timeout)
      timeout = setTimeout(() => {
        setBreakStep(prev => prev + 1)
      }, 200)
    }
  }

  const onFocusInput = () => {
    if (localStorage.getItem(RECENT_SEARCH_VARIABLE)) {
      let recentSearch: any = localStorage.getItem(RECENT_SEARCH_VARIABLE)
      setRecent(JSON.parse(recentSearch))
    }
    setFocus(true)
    setToggleClose(true)
  }

  return (
    <div className={classes.searchMobileContent} style={props.style}>
      <div className={classes.searchMobileHead}>
        <div className={classes.searchMobileBox}>
          <div className={classes.searchMobileSearchIcon}>
            <SearchIcon />
          </div>
          <input
            placeholder="Search for company"
            onFocus={onFocusInput}
            onChange={onHandleChangeInput}
            value={inputValue}
            className={classes.searchMobileSearchInput}
            type="text"
          />
          {inputValue.length !== 0 && (
            <div
              onClick={onHandleClearInput}
              className={classes.searchMobileClearIcon}
            >
              <ClearIcon />
            </div>
          )}
        </div>
        <div onClick={onClose} className={classes.searchMobileCancel}>
          Cancel
        </div>
      </div>

      {focus && (
        <div
          className={classes.searchMobileResult}
          onScroll={handleScrollContent}
        >
          {recent.length !== 0 && (
            <div className={classes.searchMobileListContainer}>
              <div className={classes.searchMobileListHeadTitle}>
                Recent Search
              </div>
              <div>
                <div className={classes.searchMobileListItemContainer}>
                  {recent.map((item: any) => (
                    <div className={classes.searchMobileListItemCache}>
                      <a
                        // to={`/company/${item.ticker}`}
                        onClick={() => {
                          history.push(`/company/${item.ticker}`)
                          props.setToggleSearch(false)
                        }}
                      >
                        <div className={classes.searchMobileListItemCacheLeft}>
                          <div
                            className={
                              classes.searchMobileListItemCacheReloadIcon
                            }
                          >
                            <RestoreIcon />
                          </div>
                          <div
                            className={
                              classes.searchMobileListItemCacheReloadText
                            }
                          >
                            {item.proper_name}
                          </div>
                        </div>
                      </a>
                      <div
                        onClick={(e: any) => onClearItemFromLocal(e, item)}
                        className={classes.searchMobileListItemCacheRight}
                      >
                        <ClearIcon />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {dymamicSearchList.length !== 0 && (
            <div className={classes.searchMobileListContainer}>
              <div className={classes.searchMobileListHeadTitle}>
                Suggestions:
              </div>
              <div>
                <div className={classes.searchMobileListItemContainer}>
                  {dymamicSearchList
                    .slice(0, visibleCount)
                    .map((item: any, index: any) => (
                      <a
                        onClick={() => {
                          history.push(`/company/${item.ticker}`)
                          props.setToggleSearch(false)
                        }}
                      >
                        <div className={classes.searchMobileListItem}>
                          {item.proper_name}
                        </div>
                      </a>
                    ))}
                </div>
              </div>

              {dymamicSearchList.length > visibleCount && (
                <div className={classes.SpinnerContainer}>
                  <img alt="spinner" src={Spinner} />
                </div>
              )}
            </div>
          )}

          {recent.length === 0 && dymamicSearchList.length === 0 && (
            <div>No result found. Please try different keyword.</div>
          )}
        </div>
      )}
    </div>
  )
}

export default SearchMobile
